module.exports = __webpack_public_path__ + "static/media/SFProText-Regular.57c84a74.ttf";